
import Vue from 'vue';

export default Vue.extend({
	name: 'BetaCallout',
	props: {
		// Beta feedback form (monday.com) opened in a new tab. The Share Feedback
		// button is hidden when empty.
		feedbackUrl: {
			type: String,
			default: '',
		},
	},
	methods: {
		onFeedbackClick () {
			if (this.feedbackUrl) {
				window.open(this.feedbackUrl, '_blank', 'noopener,noreferrer');
			}
		},
	},
});
